<div class="wrapper" *ngIf="existingTelcoForm" [formGroup]="existingTelcoForm">
  <div
    style="display: flex; align-items: center; gap: 0.5rem"
    class="sub-title required"
  >
    <mat-icon
      *ngIf="
        getErrors(insideSurveyInsideInfo.CONNECTIONS_CABLING_INFO_SUBTITLE)
      "
      style="color: red"
    >
      warning
    </mat-icon>
    <span
      i18n="
        @@survey.inside.technicalinfo.inside.section.existingtelco.title.conneactionsandcabling"
      >Connections & Cabling Info</span
    >
  </div>
  <div class="section question-section">
    <div class="questions">
      <div class="form-line">
        <span
          class="question"
          i18n="
            @@survey.inside.technicalinfo.inside.section.existingtelco.connections.question"
          >Connections</span
        >
        <div class="select-wrapper">
          <p-dropdown
            [options]="existingTelcoConnectionOptions"
            formControlName="existingTelcoConnections"
            optionLabel="label"
            optionValue="value"
            placeholder="_"
          ></p-dropdown>
        </div>
      </div>
      <div class="form-line">
        <span
          class="question"
          i18n="
            @@survey.inside.technicalinfo.inside.section.existingtelco.verticalcabling.question"
          >Existing vertical cabling</span
        >
        <div class="select-wrapper">
          <p-dropdown
            [options]="existingVerticalCablingOptions"
            formControlName="existingVerticalCabling"
            optionLabel="label"
            optionValue="value"
            placeholder="_"
          ></p-dropdown>
        </div>
      </div>
      <div class="form-line">
        <span
          class="question"
          i18n="
            @@survey.inside.technicalinfo.inside.section.existingtelco.coax.question"
          >Coax</span
        >
        <div class="select-wrapper">
          <p-dropdown
            [options]="existingTelcoCoaxOptions"
            formControlName="existingTelcoCoax"
            optionLabel="label"
            optionValue="value"
            placeholder="_"
          ></p-dropdown>
        </div>
      </div>
    </div>
    <div class="questions">
      <div class="form-line">
        <div class="question required subtitle-wrapper">
          <mat-icon
            style="color: red"
            *ngIf="
              getErrors(
                insideSurveyInsideInfo.CONNECTIONS_CABLING_INFO_SUBTITLE,
                insideSurveyInsideInfo.COAX_QUANTITY_FIELD
              )
            "
            >warning
          </mat-icon>
          <div
            class="question"
            i18n="
              @@survey.inside.technicalinfo.inside.section.existingtelco.coaxquantity"
          >
            Coax Quantity
          </div>
        </div>
        <div class="input-wrapper quantity-input">
          <input
            type="number"
            formControlName="existingTelcoCoaxQuantity"
            class="form-control"
            placeholder="0-99"
            min="0"
            max="99"
            size="1"
            maxlength="2"
          />
        </div>
      </div>
      <div class="form-line">
        <app-technical-info-question
          [question]="'Individual coax cable from basement'"
          formControlName="individualCoaxCableFromBasement"
          [options]="technicalInfoQuestionsBoolOptions"
          [isRequired]="false"
        ></app-technical-info-question>
      </div>
      <div class="form-line">
        <app-technical-info-question
          [question]="'Copper intro type'"
          formControlName="copperIntroType"
          [options]="technicalInfoQuestionsCopperIntroTypeOptions"
          [isRequired]="false"
        ></app-technical-info-question>
      </div>
    </div>
  </div>
  <div
    style="display: flex; align-items: center; gap: 0.5rem"
    class="sub-title required"
  >
    <mat-icon
      *ngIf="getErrors(insideSurveyInsideInfo.COPPER_INTROS_SUBTITLE)"
      style="color: red"
    >
      warning
    </mat-icon>
    <div
      i18n="
        @@survey.inside.technicalinfo.inside.section.existingtelco.copperIntro"
    >
      Copper Intro's
    </div>
  </div>
  <div class="section">
    <div class="counter-container" [class.mb1]="!nrOfCopperIntrosValue">
      <app-number-control
        [controlName]="'No. of copper intros'"
        [disabled]="!isAuthCanWrite"
        [count]="nrOfCopperIntros"
        (countChange)="copperIntroCountChange($event)"
      ></app-number-control>
    </div>
    <div
      class="photo-container"
      *ngFor="let temp of counter(nrOfCopperIntrosValue); let i = index"
    >
      <div class="even-flex-column">
        <app-photo-and-remark
          [photos]="pictures.outsideCopperIntroPhotos"
          [surveyId]="survey.id"
          [limit]="1"
          [isAuthCanWrite]="isAuthCanWrite"
          [isInsidePhoto]="true"
          [camera]="camera"
          [cameraLayer]="cameraLayer"
          [surveyType]="surveyType.Inside"
          [surveyPhotoType]="surveyPhotoType.OutsideCopperIntro"
          [fixedIndex]="i"
          [remarkFieldName]="outsideCopperIntroPhotoRemarkFieldName"
          componentDescriptionTitle="Copper Intro Outside {{ i + 1 }}"
          [sideBySide]="true"
        >
        </app-photo-and-remark>
      </div>

      <div class="even-flex-column">
        <app-photo-and-remark
          [photos]="pictures.insideCopperIntroPhotos"
          [surveyId]="survey.id"
          [limit]="1"
          [isAuthCanWrite]="isAuthCanWrite"
          [isInsidePhoto]="true"
          [camera]="camera"
          [cameraLayer]="cameraLayer"
          [surveyType]="surveyType.Inside"
          [surveyPhotoType]="surveyPhotoType.InsideCopperIntro"
          [fixedIndex]="i"
          [remarkFieldName]="insideCopperIntroPhotoRemarkFieldName"
          componentDescriptionTitle="Copper Intro Inside {{ i + 1 }}"
          [sideBySide]="true"
        >
        </app-photo-and-remark>
      </div>
    </div>
  </div>
  <div
    style="display: flex; align-items: center; gap: 0.5rem"
    class="sub-title required"
  >
    <mat-icon
      *ngIf="getErrors(insideSurveyInsideInfo.DESIRED_FIBER_SUBTITLE)"
      style="color: red"
    >
      warning
    </mat-icon>
    <div
      i18n="
        @@survey.inside.technicalinfo.inside.section.existingtelco.desired.fiber"
    >
      Desired Fiber Intro's
    </div>
  </div>
  <div class="section last-section">
    <div class="counter-container" [class.mb1]="!nrOfDesiredFibreIntrosValue">
      <app-number-control
        [controlName]="'No. of desired fiber intros'"
        [disabled]="!isAuthCanWrite"
        [count]="nrOfDesiredFibreIntros"
        (countChange)="fiberIntroCountChange($event)"
      ></app-number-control>
    </div>

    <div
      class="photo-container"
      *ngFor="let temp of counter(nrOfDesiredFibreIntrosValue); let i = index"
    >
      <div class="even-flex-column">
        <app-photo-and-remark
          [photos]="pictures.outsideFibreIntroPhotos"
          [surveyId]="survey.id"
          [limit]="1"
          [isAuthCanWrite]="isAuthCanWrite"
          [isInsidePhoto]="true"
          [camera]="camera"
          [cameraLayer]="cameraLayer"
          [surveyType]="surveyType.Inside"
          [surveyPhotoType]="surveyPhotoType.OutsideFibreIntro"
          [fixedIndex]="i"
          [remarkFieldName]="outsideFibreIntroPhotoRemarkFieldName"
          componentDescriptionTitle="Fiber Intro Outside {{ i + 1 }}"
        >
        </app-photo-and-remark>
      </div>

      <div class="even-flex-column">
        <app-photo-and-remark
          [photos]="pictures.insideFibreIntroPhotos"
          [surveyId]="survey.id"
          [limit]="1"
          [isAuthCanWrite]="isAuthCanWrite"
          [isInsidePhoto]="true"
          [camera]="camera"
          [cameraLayer]="cameraLayer"
          [surveyType]="surveyType.Inside"
          [surveyPhotoType]="surveyPhotoType.InsideFibreIntro"
          [fixedIndex]="i"
          [remarkFieldName]="insideFibreIntroPhotoRemarkFieldName"
          componentDescriptionTitle="Fiber Intro Inside {{ i + 1 }}"
        >
        </app-photo-and-remark>
      </div>
    </div>
  </div>
</div>
